import { render, staticRenderFns } from "./StyleEditTabSizes.vue?vue&type=template&id=5865f415&scoped=true&"
import script from "./StyleEditTabSizes.vue?vue&type=script&lang=js&"
export * from "./StyleEditTabSizes.vue?vue&type=script&lang=js&"
import style0 from "./StyleEditTabSizes.vue?vue&type=style&index=0&id=5865f415&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5865f415",
  null
  
)

export default component.exports